import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import React from 'react';
import YearMonthPicker from 'react-year-month-picker';
import { Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import convertMonthToNumeric from '../Utilities';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

class ViewBonusData extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            flag: 0,
            scheduled:
                new Date().getFullYear() + '-' + new Date().getMonth() + 1,
            sheetNames: [],
            selectedSheet: 'Select Sheet',
            columns: [],
            data: [],
            options: [],
            storeTag: '',
            alert: 0,
            alertMessage: ''
        };
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }
    async loadData() {
        await RestServices.getAllStoreTags(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then((StoreTags) => {
                if (StoreTags.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: 0,
                            alert: 1,
                            alertMessage: StoreTags.error
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({ options: StoreTags, alert: 0 });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: 0,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    handleChange(m) {
        this.setState({ flag: 0, scheduled: convertMonthToNumeric(m._i) });
        
    }

    fetchSheets = async () => {
        this.setState({ sheetNames: [], flag: 2 });

        await RestServices.getSheets(
            localStorage.getItem('FirebaseToken'),
            this.state.scheduled
        )
            .then((response) => response.json())
            .then((sheets) => {
                if (sheets.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: 0,
                            alert: 1,
                            alertMessage: sheets.error
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            flag: 1,
                            sheetNames: sheets,
                            alert: 0
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: 0,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    };

    retrieveData = async () => {
        let sheet = this.state.selectedSheet;
        let titles = [];
        let titlesArray = [];
        let retrievedData = [];

        function addToTitles(value) {
            titles = value;
        }

        function addToData(data, tag) {
            retrievedData.push({ ...data, Tag: tag });
        }

        if (this._isMounted) {
            this.setState({ flag: 2 });
        }

        await RestServices.getStoreIncentives(
            localStorage.getItem('FirebaseToken'),
            this.state.storeTag.concat('_', this.state.scheduled),
            this.state.selectedSheet
        )
            .then((response) => response.json())
            .then((doc) => {
                addToData(doc, this.state.storeTag);
            })
            .catch((err) => {});

        await RestServices.getIncentivesMetadata(
            localStorage.getItem('FirebaseToken'),
            this.state.scheduled,
            this.state.selectedSheet
        )
            .then((response) => response.json())
            .then((doc) => {
                addToTitles(doc);
            });

        for (var value in titles) {
            await titlesArray.push({
                title: titles[value],
                field: titles[value]
            });
        }
        if (this._isMounted) {
            await this.setState({
                selectedSheet: sheet,
                columns: titlesArray,
                data: retrievedData,
                flag: 3
            });
        }
    };

    render() {
        return (
            <div>
                <br />
                {this.state.flag >= 0 && this.state.flag <= 2 && (
                    <div>
                        <Row>
                            <Col sm={2}>
                                <label style={{ marginBottom: '0.3rem' }}>
                                    {' '}
                                    Select Date:
                                </label>
                            </Col>
                            <Col sm={3}>
                                <YearMonthPicker
                                    closeOnSelect
                                    defaultYear={new Date().getFullYear()}
                                    defaultMonth={new Date().getMonth() + 1}
                                    minYear={2010}
                                    maxYear={new Date().getFullYear()}
                                    onChange={this.handleChange.bind(this)}
                                />
                                <p style={{ color: 'red', fontSize: '12px' }}>
                                    *Select Month and Year to proceed
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    onClick={this.fetchSheets}
                                >
                                    Fetch
                                </Button>
                            </Col>
                        </Row>
                        <hr />
                    </div>
                )}

                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag === 2 && <Spinner animation="border" />}
                {this.state.flag > 0 && this.state.flag < 2 && (
                    <div>
                        <Row>
                            <Col sm={2}>
                                <label style={{ marginTop: '0.5rem' }}>
                                    Enter Tag:
                                </label>
                            </Col>
                            <Col sm={1.5}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        this.setState({ storeTag: newValue });
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        this.setState({
                                            storeTag: newInputValue
                                        });
                                    }}
                                    style={{ width: 300 }}
                                    freeSolo
                                    id="free-solo-2-demo"
                                    disableClearable
                                    options={this.state.options.map(
                                        (option) => option
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Store Tag"
                                            margin="normal"
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                type: 'search'
                                            }}
                                        />
                                    )}
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col sm={2}>
                                <label>Choose one sheet: </label>
                            </Col>
                            <Col sm={1.5}>
                                <DropdownButton
                                    id="dropdown-item-button"
                                    title={this.state.selectedSheet}
                                    variant=""
                                    style={{ border: '1px solid lightgrey' }}
                                >
                                    {this.state.sheetNames.map(
                                        (value, index) => {
                                            return (
                                                <Dropdown.Item
                                                    eventKey={value}
                                                    key={value}
                                                    onSelect={(value) =>
                                                        this.setState({
                                                            selectedSheet: value
                                                        })
                                                    }
                                                >
                                                    {value}
                                                </Dropdown.Item>
                                            );
                                        }
                                    )}
                                </DropdownButton>
                            </Col>
                        </Row>
                        <br />
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={this.retrieveData}
                            disabled={
                                this.state.selectedSheet === 'Select Sheet'
                            }
                        >
                            Retrieve
                        </Button>
                        <hr />
                    </div>
                )}

                {this.state.flag === 3 && this.state.flag !== 2 && (
                    <div>
                        <Row style={{ display: 'flex' }}>
                            <KeyboardBackspaceRoundedIcon
                                style={{
                                    marginLeft: '1rem',
                                    cursor: 'pointer',
                                    color: 'blue'
                                }}
                                onClick={() =>
                                    this.setState({
                                        flag: 1,
                                        selectedSheet: 'Select Sheet'
                                    })
                                }
                            />
                            <h5 style={{ marginLeft: '1rem' }}>
                                {this.state.scheduled +
                                    ' Bonus/Incentives Data'}
                            </h5>
                        </Row>
                        <hr />
                        <MaterialTable
                            components={{ Pagination: PatchedPagination }}
                            title={this.state.selectedSheet}
                            columns={this.state.columns}
                            data={this.state.data}
                            options={{
                                filtering: true,
                                pageSize: 15,
                                pageSizeOptions: [15, 25, 50, 100]
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(ViewBonusData);
